export const defaultMessageVariables = [
    {
        name: "Contact Name",
        value: "{{name}} "
    },
    {
        name: "User",
        value: "{{user.name}} "
    },
    {
        name: "Greeting",
        value: "{{ms}} "
    },
    {
        name: "Protocol Number",
        value: "{{protocol}} "
    },
    {
        name: "Date",
        value: "{{date}} "
    },
    {
        name: "Hour",
        value: "{{hour}} "
    },
    {
        name: "Ticket ID",
        value: "{{ticket_id}} "
    },
    {
        name: "Queue",
        value: "{{queue}} "
    },
    {
        name: "Connection",
        value: "{{connection}} "
    }
];
